import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function BeginnerSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-gradient-to-r from-primary-600 to-primary-700">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
          <div className="max-w-2xl">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50">
              {t('beginner.title')}
            </h2>
            <p className="mt-3 text-sm md:text-base text-background-100 leading-relaxed">
              {t('beginner.desc')}
            </p>
          </div>
          <Link
            to="/article/how-to-use-allchinabuy-spreadsheet"
            className="inline-flex items-center gap-2 rounded-md bg-background-50 px-6 py-3 text-sm md:text-base font-semibold text-primary-700 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer shrink-0"
          >
            {t('beginner.cta')}
            <span className="flex w-4 h-4 items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}